import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { useState } from 'react';
import classes from './ShowMoreText.module.css';
import {
  parseReduceText,
  // parseTextWithNewLineToElement,
} from '../../../../utils';

const ShowMoreText = ({ children, maxChar }) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <div className={`${classes.textContainer} ${showMore ? '' : classes.blur}`}>
      <p className={classes.text}>
        <ReactMarkdown linkTarget="_blank">
          {showMore ? children : parseReduceText(children, maxChar)}
        </ReactMarkdown>
      </p>
      {children.length > maxChar && (
        <button
          className={classes.button}
          type="button"
          onClick={() => setShowMore((prevShowMore) => !prevShowMore)}
        >
          {showMore ? 'Read less' : 'Read more'}
        </button>
      )}
    </div>
  );
};

ShowMoreText.propTypes = {
  children: PropTypes.string.isRequired,
  maxChar: PropTypes.number,
};

ShowMoreText.defaultProps = {
  maxChar: 245,
};

export default ShowMoreText;
